import type { TextVariant } from '@viapeople/components'
import { Text } from '@viapeople/components'
import { MarkdownPreview } from '@viapeople/components/src/components/MarkdownEditor'

export const MarkdownText = ({ markdown, variant = 'small' }: { markdown: string; variant?: TextVariant }) => {
	return (
		<Text variant={variant} className='block'>
			<MarkdownPreview markdown={markdown} className='text-left text-inherit' />
		</Text>
	)
}
